const {Dropdown, Collapse} = require('bootstrap.native/dist/bootstrap-native-v4')
const {bind} = require('./lib/bind')
require('./lib/closest')

bind(document, 'DOMContentLoaded', () => {
  Array.from(document.querySelectorAll('.js-dropdown-toggle')).forEach((element) => {
    new Dropdown(element)
  })

  Array.from(document.querySelectorAll('.navbar-toggler')).forEach((element) => {
    new Collapse(element)
  })

  Array.from(document.querySelectorAll('.alert .btn-close')).forEach((element) => {
    bind(element, 'click', function() {
      const alert = element.closest('.alert')
      alert.parentNode.removeChild(alert)
    })
  })
})
